import { render, staticRenderFns } from "./RemoveCouponModal.vue?vue&type=template&id=2921ef70"
import script from "./RemoveCouponModal.vue?vue&type=script&lang=js"
export * from "./RemoveCouponModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports